export default "__VITE_ASSET__Cew0lNxu__"